/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { ValuesOf } from '@tmapy/beetlejuice-utils';

/**
 * ```yaml
 * type: string
 * description: |-
 *   * `STATE` - State
 *   * `CHANGE` - Change
 * ```
 */
export const OrderTypeEnum = { STATE: 'STATE', CHANGE: 'CHANGE' } as const;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type OrderTypeEnum = ValuesOf<typeof OrderTypeEnum>;

export type OrderTypeEnumRequest = OrderTypeEnum;
export type OrderTypeEnumResponse = OrderTypeEnum;
